import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
@Injectable({
  providedIn: 'root'
})
export class TranslationLoaderService {
  public dataAvailable:BehaviorSubject<any> = new BehaviorSubject(false);
  constructor(private translate: TranslateService){
  }

  // public loadTranslations(lang: string, data: any): void{
  //     if (lang === undefined) {
  //         lang = 'en_US';
  //     }
      public loadTranslations(lang: string, data: any): void{
      //this.translate.setDefaultLang(lang);
     // this.translate.use(lang);
      this.translate.setTranslation(lang, {
                      ct: data
                  });
      this.translate.use(lang);
      this.dataAvailable.next(true);
  }
}
